<div class="table-header">
  <div class="table-header-content">
    <h3>Candidate Proctoring Reports</h3>

    <p>
      Every candidate assessment attempt with integrity score, violations, and
      access to the detailed proctoring report.
    </p>
  </div>
</div>
<ng-container *ngIf="isInitialLoad; else showPage">
  <div class="app-spinner">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
</ng-container>

<ng-template #showPage>
   <hr class="dashboard-divider" />
    <div class="table-wrapper">
      <div class="table-filters">
        <div class="search-row">
          <div class="search-box">
            <i class="fa fa-search" *ngIf="!searchText"></i>
            <i *ngIf="searchText" class="bi bi-x" (click)="searchText = ''; searchSubject.next('')" style="cursor: pointer; font-size: 1.2rem; z-index: 10;"></i>
            <input
              type="text"
              [(ngModel)]="searchText"
              (input)="onSearch($event)"
              placeholder="Search by Candidate Name or Email..."
            />
          </div>
        </div>

        <div class="filter-row">
          <!-- <div class="filter-item">
            <select [(ngModel)]="selectedAssessment" (change)="applyFilters()">
              <option *ngFor="let item of assessments" [value]="item">
                {{ item }}
              </option>
            </select>
          </div> -->

          <div class="filter-item">
            <select [(ngModel)]="selectedStatus" (change)="applyFilters()">
              <option *ngFor="let item of statuses" [value]="item.value">
                {{ item.label }}
              </option>
            </select>
          </div>


          <div class="filter-item">
            <input
              type="date"
              [(ngModel)]="sessionDateInput"
              matTooltip="Session Created"
              matTooltipPosition="above"
              [min]="minDate"
              [max]="maxDate"
              (keydown)="$event.preventDefault()"
              (paste)="$event.preventDefault()"
              (change)="applyFilters()"
            />
          </div>

          <div class="filter-item integrity-filter">
            <button
              type="button"
              class="filter-btn"
              (click)="toggleIntegrityPopup()"
            >
              <i class="fa fa-sliders"></i>
              Integrity Score
              <i class="fa fa-chevron-down"></i>
            </button>

            <div class="integrity-popup" *ngIf="showIntegrityPopup">
              <div style="display: flex; justify-content: space-between; margin-bottom: 10px;">
                <h6 style="margin: 0; font-size: 14px; font-weight: 600; color: #111827;">Integrity Score</h6>
                <i class="bi bi-x" (click)="showIntegrityPopup = false" style="cursor: pointer; font-size: 1.2rem; line-height: 1;"></i>
              </div>
              <div class="integrity-range">
                <div class="range-field">
                  <label>Minimum</label>
                  <input
                    type="number"
                    [(ngModel)]="minIntegrity"
                    placeholder="0"
                    min="0"
                    max="100"
                    (keypress)="preventNonNumericalInput($event)"
                  />
                </div>

                <div class="range-field">
                  <label>Maximum</label>
                  <input
                    type="number"
                    [(ngModel)]="maxIntegrity"
                    placeholder="100"
                    min="0"
                    max="100"
                    (keypress)="preventNonNumericalInput($event)"
                  />
                </div>
              </div>
              <div *ngIf="getValidationError()" style="color: #dc2626; font-size: 11px; margin-top: 8px;">
                {{ getValidationError() }}
              </div>

              <div class="popup-actions">
                <button class="cancel-btn" (click)="resetIntegrityFilter()">
                  Reset
                </button>

                <button class="apply-btn" (click)="applyIntegrityFilter()" [disabled]="!!getValidationError()">
                  Apply
                </button>
              </div>
            </div>
          </div>
          <!-- 
      <div class="filter-item column-filter">
        <button
          class="filter-btn"
          (click)="toggleColumnDropdown(); $event.stopPropagation()"
        >
          <i class="fa fa-columns"></i>
          Columns
          <i class="fa fa-chevron-down"></i>
        </button>

        <div
          class="column-dropdown"
          *ngIf="showColumnDropdown"
          (click)="$event.stopPropagation()"
        >
          <label *ngFor="let column of columns">
            <input
              type="checkbox"
              [(ngModel)]="column.visible"
              (change)="updateColumns()"
            />

            {{ column.name }}
          </label>
        </div>
      </div> -->
        </div>
      </div>

      <div class="report-table">
        <div class="table-scroll-container">
        <table>
          <thead>
            <tr>
              <th *ngIf="columns[0].visible">
                CANDIDATE
                <span class="material-icons sort-icon" (click)="sortBy('candidateName')"> swap_vert </span>
              </th>

              <th *ngIf="columns[1].visible">
                ASSESSMENT CODE
                <span class="material-icons sort-icon" (click)="sortBy('proctoringEvaluationOnId')"> swap_vert </span>
              </th>

              <th *ngIf="columns[2].visible">
                ASSESSMENT TYPE
                <span class="material-icons sort-icon" (click)="sortBy('proctoringEvaluationOn')"> swap_vert </span>
              </th>

              <th *ngIf="columns[3].visible">
                STATUS
                <span class="material-icons sort-icon" (click)="sortBy('sessionStatus')"> swap_vert </span>
              </th>

              <th *ngIf="columns[4].visible">
                INTEGRITY SCORE
                <span class="material-icons sort-icon" (click)="sortBy('integrityScore')"> swap_vert </span>
              </th>

              <th *ngIf="columns[5].visible">
                VIOLATIONS
                <span class="material-icons sort-icon" (click)="sortBy('totalViolations')"> swap_vert </span>
              </th>

              <th *ngIf="columns[6].visible">
                ASSESSMENT DATE
                <span class="material-icons sort-icon" (click)="sortBy('startedAt')"> swap_vert </span>
              </th>

              <th *ngIf="columns[7].visible">ACTIONS</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngIf="isLoading">
              <td colspan="8" style="padding: 40px 0; text-align: center;">
                <mat-spinner diameter="50" style="margin: 0 auto;"></mat-spinner>
              </td>
            </tr>
            <ng-container *ngIf="!isLoading && candidateData.length > 0">
            <tr *ngFor="let candidate of candidateData">
              <td *ngIf="columns[0].visible">
                <div class="candidate">
                  <div class="name">{{candidate.summary.candidateName}}</div>
                  <div class="email">{{candidate.summary.candidateEmail}}</div>
                </div>
              </td>

              <td *ngIf="columns[1].visible">
                {{ candidate.summary.proctoringEvaluationOnId || "-" }}
              </td>

              <td *ngIf="columns[2].visible">{{candidate.summary.proctoringEvaluationOn || '-'}}</td>

              <td *ngIf="columns[3].visible">
                <span
                  class="badge"
                  [ngClass]="{
                    success: candidate.summary.sessionStatus === 'ACTIVE' ||
                    candidate.summary.sessionStatus === 'COMPLETED',
                    warning: candidate.summary.sessionStatus === 'REQUESTED',
                    danger: candidate.summary.sessionStatus === 'Terminated' || 
                    candidate.summary.sessionStatus === 'ABANDONED',
                  }"
                >
                  <span class="dot"></span>

                  {{ candidate.summary.sessionStatus || '-' }}
                </span>
              </td>

              <td *ngIf="columns[4].visible">
                {{ candidate.summary.integrityScore || "0" }}%
              </td>

              <td *ngIf="columns[5].visible">
                {{ candidate.summary.totalViolations }}
              </td>

              <td *ngIf="columns[6].visible">
                {{ candidate.summary.startedAt | date: "dd MMM yyyy" }}
              </td>

              <td *ngIf="columns[7].visible">
                <ng-container *hasPermission="PermissionForStudents.PROCTORING_READ">
                <span
                  class="view-report"
                  (click)="goToProtoCandidateDetailPage(candidate.sessionId)"
                >
                  <i class="fa fa-eye"></i>
                  View Report
                </span>
                </ng-container>
              </td>
            </tr>
            </ng-container>
            <tr *ngIf="!isLoading && candidateData.length === 0">
              <td colspan="8">
                <div class="empty-state text-center p-5 mt-4 mb-4">
                  <i class="fa fa-search" style="font-size:1rem; color: #cbd5e1; margin-bottom: 1rem; display: block;"></i>
                  <h4 style="color: #475569; font-weight: 600;">No candidates found</h4>
                  <p class="text-muted mt-2">We couldn't find any candidate matching your search. Try using a different name, email, or adjusting your filters.</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        </div>

        <div class="table-pagination" *ngIf="candidateData.length > 0">
          <div class="pagination-left">
            Showing <b>{{ startRecord }} -{{ endRecord }}</b> of
            <b>{{ totalCandidate }}</b>

            <span>Rows per page</span>

            <select [(ngModel)]="pageSize" (change)="changePageSize()">
              <option [ngValue]="5">5</option>
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
            </select>
          </div>

          <div class="pagination-right">
            <button
              type="button"
              [disabled]="currentPage === 1"
              (click)="previousPage()"
            >
              Previous
            </button>

            <span> Page 
              <select [(ngModel)]="currentPage" (change)="goToPage(currentPage)">
                <option *ngFor="let page of pagesArray" [ngValue]="page">{{ page }}</option>
              </select>
              of {{ totalPages }} 
            </span>

            <button
              type="button"
              [disabled]="currentPage === totalPages"
              (click)="nextPage()"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
</ng-template>
